import React, { Component } from "react";
import VisibilityIcon from "@material-ui/icons/Visibility";
import VisibilityOffIcon from "@material-ui/icons/VisibilityOff";
import CreateIcon from "@material-ui/icons/Create";
import { connect } from "react-redux";

import { addSettings } from "../../../actions";
import {
  listDomains,
  deletePage,
  disableDomainSubmit,
  deleteDomainSubmit,
  connectDomainSubmit,
} from "./../../../config/domain_api_calls";
import $ from "jquery";
import DataTable from "../../../components/Tables/DataTable";
import { tableLoader } from "../../../components/ContentLoaders/table_loader";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import { THEME_TEXT_COLOR, THEME_COLOR } from "./../../../config/config";
import MutextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Box from "@material-ui/core/Box";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Tooltip from "@material-ui/core/Tooltip";
import dateFormat, { masks } from "dateformat";

const auth = new HelperClass();

class Domains extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      errorMessage: "",
      serviceId: "",
      successMessage: "",
      waitMessage: "",
      tableLoader: true,
      delete_id: "",
      defaultNrc: "",
      defaultMrc: "",
      new_nrc: "",
      new_mrc: "",
      rate_type: "",
      rate: "",
      update_nrc: "",
      update_mrc: "",
      update_rate: "",
      product_id: "",
      product_desc: "",
      mrc_rate_type: "Flat",
      service_title: "",
      service_type_edit: "",
      confirm_status: "",
      disable_status: "",
      delete_status: "",
      domain_id: "",
      domain_name: "",
      is_verified: "",
      btn_loader: false,
      columnServices: [
        { name: "Domain Title" },
        { name: "Domain Name" },

        {
          name: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.defaultText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Verified",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.verifiedText(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Date Added",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "Action",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>
                  <div
                    className="nk-tb-col nk-tb-col-tools"
                    style={{ padding: "0px" }}
                  >
                    <ul className="nk-tb-actions gx-1">
                      <li>
                        <div className="drodown">
                          <a
                            href="#"
                            title="Other Actions"
                            className="dropdown-toggle btn btn-icon  btn-outline-light"
                            data-toggle="dropdown"
                          >
                            <em className="icon ni ni-more-h"></em>
                          </a>
                          <div className="dropdown-menu dropdown-menu-right">
                            <ul className="link-list-opt no-bdr">
                              <li>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    this.connectDomain(value, tableMeta)
                                  }
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                    this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-grid-add-c"></em>
                                  <span>Connect Domain</span>
                                </a>
                              </li>
                              <li>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    this.disableDomain(value, tableMeta)
                                  }
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                    this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-na"></em>
                                  <span>Disconnect Domain</span>
                                </a>
                              </li>
                              <li>
                                <a
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    this.deleteDomain(value, tableMeta)
                                  }
                                  disabled={
                                    this.props.is_msa_signed === "No" ||
                                    this.props.defaultSettings === "missing"
                                      ? true
                                      : false
                                  }
                                >
                                  <em className="icon ni ni-cross-round"></em>
                                  <span>Delete Domain</span>
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              );
            },
          },
        },
      ],
    };
  }

  viewBtns = () => {
    if (
      this.props.is_msa_signed === "No" ||
      this.props.defaultSettings === "missing"
    ) {
      return <VisibilityOffIcon />;
    } else {
      return <VisibilityIcon style={{ cursor: "pointer" }} />;
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  defaultText = (value, tableMeta) => {
    let is_default = tableMeta.rowData[2];
    if (is_default === "Connected") {
      return (
        <Tooltip title="Domain is connected and assigned" placement="top">
          <span className="badge badge-outline-success">
            <em className="icon ni ni-done"></em> Connected
          </span>
        </Tooltip>
      );
    } else if (is_default === "Not Connected") {
      return (
        <Tooltip title="Domain is added but not assigned" placement="top">
          <span className="badge badge-outline-warning">
            <em className="icon ni ni-na"></em> Not Connected
          </span>
        </Tooltip>
      );
    } else if (is_default === "Pending") {
      return (
        <Tooltip
          title="Domain is added but pending configuration"
          placement="top"
        >
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-na"></em> Pending
          </span>
        </Tooltip>
      );
    } else if (is_default === "Cancelled") {
      return (
        <span className="badge badge-outline-danger">
          <em className="icon ni ni-cross-round"></em> Cancelled
        </span>
      );
    } else {
      return "Inactive";
    }
  };

  verifiedText = (value, tableMeta) => {
    let is_default = tableMeta.rowData[3];
    if (is_default === "Yes") {
      return (
        <Tooltip title="DNS verified" placement="top">
          <span className="badge badge-outline-success">
            <em className="icon ni ni-done"></em> Yes
          </span>
        </Tooltip>
      );
    } else {
      return (
        <Tooltip title="DNS not verified" placement="top">
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-na"></em> Verify Domain
          </span>
        </Tooltip>
      );
    }
  };

  format_date = (value, tableMeta) => {
    let date = tableMeta.rowData[4];
    return dateFormat(date, "mm-dd-yyyy, h:MM:ss TT");
  };

  connectDomain = async (value, tableMeta) => {
    //modalConfirm
    let status = tableMeta.rowData[2];
    if (status === "Connected") {
      this.setState({
        confirm_status: "This domain is already connected.",
      });
    } else {
      this.setState({
        confirm_status: "Are you sure you want to connect this domain. ",
        domain_id: tableMeta.rowData[5],
        domain_name: tableMeta.rowData[1],
        is_verified: tableMeta.rowData[3],
      });
    }
    window.$("#modalConfirm").modal("show");
  };

  connectDomainSubmit = async () => {
    let { domain_id, domain_name, is_verified } = this.state;
    const disableResponce = await connectDomainSubmit(
      auth.getAccount(),
      auth.getToken(),
      domain_id,
      domain_name,
      is_verified
    );
    // console.log("connectDomainSubmit.data: ", disableResponce.data);
    this.setState({
      btn_loader: true,
    });
    if (
      disableResponce.data.status === 403 ||
      disableResponce.data.errors === "authentication missing" ||
      disableResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      disableResponce.data.status === 404 &&
      disableResponce.data.message === "config_error"
    ) {
      this.setState({
        errorMessage: "There is some error while connecting the domain.",
        successMessage: "",
      });
    } else if (
      disableResponce.data.status === 404 &&
      disableResponce.data.message !== "config_error"
    ) {
      this.setState({
        errorMessage:
          "There is some error while adding the domain configuration.",
        successMessage: "",
      });
    } else if (
      disableResponce.data.status === 404 &&
      disableResponce.data.message !== "verify_error"
    ) {
      this.setState({
        errorMessage: "DNS records of given domain are not verified.",
        successMessage: "",
      });
    } else if (
      disableResponce.data.status === 404 &&
      disableResponce.data.message !== "remove_config_error"
    ) {
      this.setState({
        errorMessage:
          "There is some error while removing the domain configuration.",
        successMessage: "",
      });
    } else if (
      disableResponce.data.status === 200 &&
      disableResponce.data.message === "success"
    ) {
      this.setState({
        successMessage:
          "Your request has been received. It will be processed in 5 to 10 minutes.",
        errorMessage: "",
      });
    } else {
      this.setState({
        errorMessage: "There is some error while connecting the domain.",
        successMessage: "",
      });
    }
    setTimeout(() => {
      this.setState({
        successMessage: "",
        errorMessage: "",
        btn_loader: false,
      });
    }, 4000);
  };

  disableDomain = async (value, tableMeta) => {
    //modalConfirm
    let status = tableMeta.rowData[2];
    if (status !== "Connected") {
      this.setState({
        disable_status: "This domain is already disconnected.",
      });
    } else {
      this.setState({
        disable_status:
          "Are you sure you want to disconnect this domain. You will not be able to access the portal after disconnecting it.",
        domain_id: tableMeta.rowData[5],
        domain_name: tableMeta.rowData[1],
        is_verified: tableMeta.rowData[3],
      });
    }
    window.$("#modalDisable").modal("show");
  };

  disableDomainSubmit = async () => {
    let { domain_id, domain_name, is_verified } = this.state;
    const disableResponce = await disableDomainSubmit(
      auth.getAccount(),
      auth.getToken(),
      domain_id,
      domain_name,
      is_verified
    );
    // console.log("disableResponce.data: ", disableResponce.data);
    this.setState({
      btn_loader: true,
    });
    if (
      disableResponce.data.status === 403 ||
      disableResponce.data.errors === "authentication missing" ||
      disableResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      disableResponce.data.status === 404 &&
      disableResponce.data.message === "config_error"
    ) {
      this.setState({
        errorMessage:
          "There is some error while removing the domain configuration.",
        successMessage: "",
      });
    } else if (
      disableResponce.data.status === 404 &&
      disableResponce.data.message !== "config_error"
    ) {
      this.setState({
        errorMessage: "There is some error while disconnecting the domain.",
        successMessage: "",
      });
    } else if (
      disableResponce.data.status === 200 &&
      disableResponce.data.message === "success"
    ) {
      this.setState({
        successMessage:
          "Your request has been received. It will be processed in 5 to 10 minutes.",
        errorMessage: "",
      });
    } else {
      this.setState({
        errorMessage: "There is some error while disconnecting the domain.",
        successMessage: "",
      });
    }
    setTimeout(() => {
      this.setState({
        successMessage: "",
        errorMessage: "",
        btn_loader: false,
      });
    }, 4000);
  };

  deleteDomain = async (value, tableMeta) => {
    //modalConfirm
    let status = tableMeta.rowData[2];

    this.setState({
      delete_status: "Are you sure you want to delete this domain. ",
      domain_id: tableMeta.rowData[5],
      domain_name: tableMeta.rowData[1],
      is_verified: tableMeta.rowData[3],
    });

    window.$("#modalDelete").modal("show");
  };

  deleteDomainSubmit = async () => {
    let { domain_id, domain_name, is_verified } = this.state;
    const disableResponce = await deleteDomainSubmit(
      auth.getAccount(),
      auth.getToken(),
      domain_id,
      domain_name,
      is_verified
    );
    this.setState({
      btn_loader: true,
    });
    // console.log("disableResponce.data: ", disableResponce.data);

    if (
      disableResponce.data.status === 403 ||
      disableResponce.data.errors === "authentication missing" ||
      disableResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (disableResponce.data.status === 404) {
      this.setState({
        errorMessage:
          "There is some error while removing the domain configuration.",
        successMessage: "",
      });
    } else if (
      disableResponce.data.status === 200 &&
      disableResponce.data.message === "config_error"
    ) {
      this.setState({
        errorMessage: "",
        successMessage:
          "Your request has been received. It will be processed in 5 to 10 minutes.",
      });
    } else if (
      disableResponce.data.status === 200 &&
      disableResponce.data.message === "success"
    ) {
      this.setState({
        successMessage: "Domain deleted successfully.",
        errorMessage: "",
      });
    } else {
      this.setState({
        errorMessage: "There is some error while deleting the domain.",
        successMessage: "",
      });
    }
    setTimeout(() => {
      this.setState({
        successMessage: "",
        errorMessage: "",
        btn_loader: false,
      });
    }, 4000);
  };

  publishText = (value, tableMeta) => {
    let is_default = tableMeta.rowData[4];
    if (is_default === 1) {
      return "Yes";
    } else {
      return "No";
    }
  };

  async componentDidMount() {
    const servicesResponce = await listDomains(
      auth.getAccount(),
      auth.getToken()
    );
    // console.log("servicesResponce.data: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (servicesResponce.data.status === 404) {
      this.setState({
        errorMessage: "There is some error while getting the domains.",
        successMessage: "",
      });
      //window.location.replace("/error");
    } else if (
      servicesResponce.data.status === 200 &&
      servicesResponce.data.message === "success"
    ) {
      this.setState({
        tableData: servicesResponce.data.data,
        tableLoader: false,
      });
    } else {
      this.setState({
        errorMessage: "There is some error while getting the domains.",
        successMessage: "",
      });
    }
  }

  setMarkUp = async (value, tableMeta) => {
    await this.handleStatesDynamic(
      tableMeta.rowData[0],
      tableMeta.rowData[3].replace("$", ""),
      tableMeta.rowData[4].replace("$", ""),
      tableMeta.rowData[6].replace("$", ""),
      tableMeta.rowData[1],
      tableMeta.rowData[5]
    );
    // console.log("setMarkupData: ", this.state.service_title);
    window.$("#modalForm").modal("show");
  };

  handleStatesDynamic = async (
    serviceId,
    update_nrc,
    update_mrc,
    update_rate,
    service_title,
    service_type_edit
  ) => {
    this.setState({
      serviceId: serviceId,
      update_nrc: update_nrc,
      update_mrc: update_mrc,
      update_rate: update_rate,
      service_title: service_title,
      service_type_edit: service_type_edit,
    });
  };

  showDetails = (value, tableMeta) => {
    this.setState({
      product_desc: tableMeta.rowData[7],
    });
    window.$("#modalFormDetail").modal("show");
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  calculatePercent = (percent, num) => {
    return (percent / 100) * num;
  };
  modalHide = () => {
    window.$("#modalFormDetail").modal("hide");
  };

  modalHideDel = () => {
    window.$("#modalDeleteAlert").modal("hide");
  };

  checkNumber = async (evt) => {
    var theEvent = evt || window.event;
    var key = theEvent.keyCode || theEvent.which;
    var keyCode = key;
    key = String.fromCharCode(key);
    if (key.length == 0) return;
    var regex = /^[0-9.\b]+$/;
    if (keyCode == 188 || keyCode == 190) {
      return;
    } else {
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    }
  };

  render() {
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");

    return (
      <div className="nk-content " id="Cms_Block">
        <div className="container-fluid">
          {this.props.defaultSettings === "missing" &&
          this.props.from !== "dashboard" ? (
            <SettingsError />
          ) : null}
          {/* MSA WARNING  START*/}
          {this.props.is_msa_signed === "No" &&
          this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}

          {/* MSA WARNING END */}

          <div className="nk-content-inner">
            <div className="nk-content-body">
              {/* PAGE TITLE START */}
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <PageTitle name="Manage Domains" icon="icon ni ni-link" />
                    </h3>
                  </div>
                  <div className="nk-block-head-content" id="HeadContent">
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#"
                        className="btn btn-icon btn-trigger toggle-expand mr-n1"
                        data-target="pageMenu"
                      >
                        <em className="icon ni ni-more-v"></em>
                      </a>
                      <div
                        className="toggle-expand-content"
                        data-content="pageMenu"
                      >
                        <ul className="nk-block-tools g-3">
                          <li className="nk-block-tools-opt">
                            <a
                              style={{ color: "#ffffff" }}
                              onClick={() =>
                                this.addMenuHistory("/domains/Adddomains")
                              }
                              className="btn btn-primary"
                            >
                              <em className="icon ni ni-plus-round"></em>
                              <span>Add Domain</span>
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* PAGE TITLE END */}
              <div className="nk-block">
                <div className="row g-gs">
                  <div className="col-xxl-12">
                    <div className="nk-block nk-block-lg">
                      {/* START DATATABLE */}
                      {this.state.tableLoader === true ? (
                        tableLoader()
                      ) : (
                        <DataTable
                          columns={this.state.columnServices}
                          tableData={this.state.tableData}
                          title="All Domains"
                        />
                      )}
                      {/* END TABLE */}
                    </div>
                  </div>
                  <br />
                  <div className="modal fade" tabIndex="-1" id="modalConfirm">
                    <div
                      className="modal-dialog modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-header">
                          <h5 className="modal-title">Connect Domain</h5>
                        </div>
                        <div className="modal-body">
                          <p>{this.state.confirm_status}</p>
                        </div>
                        <div
                          className="modal-footer bg-light"
                          style={{
                            float: "right",
                            textAlign: "right",
                            justifyContent: "flex-end",
                          }}
                        >
                          {this.state.confirm_status !==
                          "This domain is already connected." ? (
                            <>
                              {this.state.btn_loader === true ? (
                                <button
                                  className="btn btn-dim btn-primary"
                                  disabled
                                >
                                  <em className="icon ni ni-swap"></em> Connect
                                  <div
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                </button>
                              ) : (
                                <a
                                  onClick={() => {
                                    this.connectDomainSubmit();
                                  }}
                                  className="btn btn-dim btn-primary"
                                >
                                  Connect
                                </a>
                              )}
                            </>
                          ) : null}
                          <a
                            href="#"
                            className="btn btn-dim btn-danger"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="modal fade" tabIndex="-1" id="modalDisable">
                    <div
                      className="modal-dialog modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-header">
                          <h5 className="modal-title">Disconnect Domain</h5>
                        </div>
                        <div className="modal-body">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "20px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "20px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <p>{this.state.disable_status}</p>
                        </div>
                        <div
                          className="modal-footer bg-light"
                          style={{
                            float: "right",
                            textAlign: "right",
                            justifyContent: "flex-end",
                          }}
                        >
                          {this.state.disable_status !==
                          "This domain is already disconnected." ? (
                            <>
                              {this.state.btn_loader === true ? (
                                <button
                                  className="btn btn-dim btn-primary"
                                  disabled
                                >
                                  <em className="icon ni ni-swap"></em>{" "}
                                  Disconnect
                                  <div
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                </button>
                              ) : (
                                <a
                                  onClick={() => {
                                    this.disableDomainSubmit();
                                  }}
                                  className="btn btn-dim btn-primary"
                                >
                                  Disconnect
                                </a>
                              )}
                            </>
                          ) : null}
                          <a
                            href="#"
                            className="btn btn-dim btn-danger"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal fade" tabIndex="-1" id="modalDelete">
                    <div
                      className="modal-dialog modal-dialog-top"
                      role="document"
                    >
                      <div className="modal-content">
                        <a
                          href="#"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                        >
                          <em className="icon ni ni-cross"></em>
                        </a>
                        <div className="modal-header">
                          <h5 className="modal-title">Delete Domain</h5>
                        </div>
                        <div className="modal-body">
                          {this.state.errorMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "20px" }}
                            >
                              <div className="alert alert-pro alert-danger">
                                <div className="alert-text">
                                  <h4>Error</h4>
                                  <p>{this.state.errorMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          {this.state.successMessage !== "" ? (
                            <div
                              className="example-alert"
                              style={{ marginBottom: "20px" }}
                            >
                              <div className="alert alert-pro alert-success">
                                <div className="alert-text">
                                  <h4>Success</h4>
                                  <p>{this.state.successMessage}</p>
                                </div>
                              </div>
                            </div>
                          ) : null}
                          <p>{this.state.delete_status}</p>
                        </div>
                        <div
                          className="modal-footer bg-light"
                          style={{
                            float: "right",
                            textAlign: "right",
                            justifyContent: "flex-end",
                          }}
                        >
                          {this.state.delete_status !==
                          "This domain is already connected." ? (
                            <>
                              {this.state.btn_loader === true ? (
                                <button
                                  className="btn btn-dim btn-primary"
                                  disabled
                                >
                                  <em className="icon ni ni-swap"></em> Delete
                                  <div
                                    className="spinner-grow spinner-grow-sm"
                                    role="status"
                                  >
                                    <span className="sr-only">Loading...</span>
                                  </div>
                                </button>
                              ) : (
                                <a
                                  onClick={() => {
                                    this.deleteDomainSubmit();
                                  }}
                                  className="btn btn-dim btn-primary"
                                >
                                  Delete
                                </a>
                              )}
                            </>
                          ) : null}
                          <a
                            href="#"
                            className="btn btn-dim btn-danger"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            Cancel
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Domains);
